export default "__VITE_ASSET__bd76ed4c__"